/* --------------------------------------------------------------------------------------
   app.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

import angular from "angular";
import uiRouter from "@uirouter/angularjs";
import "angular-translate";
import "angular-translate-loader-static-files";

require("angular-moment");
require("angular-sanitize");
require("angular-cookies");
require("ng-mask");

import { appCommonModule } from "./common/common";
import { appXrxWrappersModule } from "./xrxWrappers/xrxWrappers";

import { appBrowser } from "./browser/browser.module";
import { appScan } from "./scan/scan.module";
import { appPrint } from "./print/print.module";

import { mainComponent, mainCtrl } from "./components/main.component";
import { loginComponent } from "./components/login.component";

import { mainActionBarComponent } from "./components/mainActionBar.component";
import { errorAlertComponent } from "./components/errorAlert.component";
import { settingsPopupComponent } from "./components/settingsPopup.component";
import { settingsActionBarComponent } from "./components/settingsActionBar.component";
import { redirectComponent } from "./components/redirect.component";
import { cliossoComponent } from "./components/cliosso.component";
import { xeroxssoComponent } from "./components/xeroxsso.component";
import { privacyStatementComponent } from "./components/privacyStatement.component";
import { privacyStatementEnComponent } from "./components/privacyStatements.component";

import { expensesService } from "./services/expenses.service";
import { privacyStatementLanguageService } from "./services/privacyStatementLanguage.service";
import { appSettings } from "./constants/appSettings.const";
import { authClient } from "./constants/authClient.const";

import { xeroxEIPParameters } from "./constants/xeroxEIPParameters.const";

export default angular
  .module("app", [
    "ui.router",
    "angularMoment",
    "pascalprecht.translate",
    "ngMask",
    "ngSanitize",
    "ngCookies",
    "app.common",
    "app.xrxWrappers",
    "app.browser",
    "app.scan",
    "app.print",
  ])
  .component("main", mainComponent)
  .component("privacyStatement", privacyStatementComponent)
  .component("login", loginComponent)
  .controller("mainCtrl", mainCtrl)
  .component("mainActionBar", mainActionBarComponent)
  .component("privacyStatementEn", privacyStatementEnComponent)
  .component("settingsActionBar", settingsActionBarComponent)
  .component("settingsPopup", settingsPopupComponent)
  .component("redirect", redirectComponent)
  .component("cliosso", cliossoComponent)
  .component("xeroxsso", xeroxssoComponent)
  .component("errorAlert", errorAlertComponent)
  .service("expensesService", expensesService)
  .service("privacyStatementLanguageService", privacyStatementLanguageService)
  .constant("appSettings", appSettings)
  .constant("authClient", authClient)
  .constant("xeroxEIPParameters", xeroxEIPParameters)

  .config(($stateProvider, $urlRouterProvider, $locationProvider) => {
    $locationProvider.html5Mode(true);
    $stateProvider
      .state("main", {
        component: "main",
        resolve: {
          /*@ngInject*/
          translateReady: ($translate, deviceInfoService) => {
            return $translate.onReady().then(() => {
              const lang = deviceInfoService.getLanguageSync();
              $translate.use(lang);
              //$translate.use('en')
            });
          },
        },
      })
      .state("login", {
        url: "/",
        component: "login",
      })
      .state("redirect", {
        component: "redirect",
      })
      .state("cliosso", {
        url: "/cliosso",
        component: "cliosso",
        resolve: {
          /*@ngInject*/
          translateReady: ($translate, deviceInfoService) => {
            return $translate.onReady().then(() => {
              const lang = deviceInfoService.getLanguageSync();
              $translate.use(lang);
              //$translate.use('en')
            });
          },
        },
      })
      .state("xeroxsso", {
        url: "/xeroxsso",
        component: "xeroxsso",
      })
      .state("scan", {
        component: "scanBrowse",
      })
      .state("scanSettings", {
        component: "scanSettings",
      })
      .state("print", {
        component: "printBrowse",
      })
      .state("printSettings", {
        component: "printSettings",
      })
      .state("scanClientSearch", {
        component: "scanClientSearch",
      })
      .state("scanMatterSearch", {
        component: "scanMatterSearch",
      })
      .state("printClientSearch", {
        component: "printClientSearch",
      })
      .state("printMatterSearch", {
        component: "printMatterSearch",
      });

    $urlRouterProvider.otherwise("/");
  })
  .config(($translateProvider) => {
    /*@ngInject*/
    $translateProvider.useStaticFilesLoader({
      files: [
        {
          prefix: "./i18n/locale-",
          suffix: ".json",
        },
      ],
    });
    $translateProvider.preferredLanguage("en");
    $translateProvider.useSanitizeValueStrategy("sanitizeParameters");
  })
  .filter("trusted", [
    "$sce",
    function ($sce) {
      //ES6 this
      return function (url) {
        return $sce.trustAsResourceUrl(url);
      };
    },
  ]);



// WEBPACK FOOTER //
// ./src/app/app.js